import type { FaireProductEntity } from "../../entity_types/product";

export const p_66g3b06eta: FaireProductEntity = {
  token: "p_66g3b06eta",
  type: "product",
  name: "Rib Knit Stripe Baby Legging Pants (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/98ee1f90d78bb9918f70f5e72ed4c88734f43cb5220d63470e83c1972c6ea424.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4d21961d559bf68958f08923fc24d94b8819448e752e1e0842c3e3bc9a1a528.png",
    "https://cdn.faire.com/fastly/f4b63e89fac995decbab3afe3232e9bac4468bbb914f47b3f83b38f0d30ef190.png",
    "https://cdn.faire.com/fastly/1f1427a72735f79a2e5b8f0369c0bf0d96f07cf324ed11a1ca653b1c67cc7f7d.png",
    "https://cdn.faire.com/fastly/aeb1e99d7bdca682063cc5b7408dbe925c597ea241eb3adcf7350e4250f6b590.png",
    "https://cdn.faire.com/fastly/9f54e77064595114440b2785adb2055095a953edb8c696fcfbfcf5cd839c68e3.png",
  ],
  priceDollars: 10,
  description:
    "Versatile organic cotton baby legging with elastic waist to ensure a comfy fit.\nPairs with just about everything, super cute.\nMade of organic cotton rib knit with a lot of stretch for easy fit and comfort.\nClassic and adorable design with meticulous detailing.\nSuper Soft, lightweight, all-season, cozy and comfy.\nChemical free & non-toxic formulation, eco-friendly.\n\nViverano, an American brand, was founded in 2013 with the simple idea of producing eco-friendly, pure and organic baby clothes. Viverano baby clothing is known for its soft hand feel and high quality. Pamper your precious babies with our non-toxic, lightweight, all-season, natural baby outfits.\n\nExperience 'Organic Comfort' by Viverano, a family-owned small business.\nEthically produced in India, supporting better livelihoods for small grower farmers.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:35.046Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
